import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// The theme is the single source of truth for every `color="primary"` and
// `primary--text` in the app — 195 files. It used to sit on a bright blue while
// the revamp screens were built on the navy `--o-primary` token, so the two
// halves of the product never matched. These values now mirror app_css/tokens.scss;
// change them there and here together.
//
// The status colours moved for the same reason plus contrast: the old values were
// used as text on white (outlined chips) and failed WCAG AA — success #27AE60 was
// 2.80:1, warning #F18324 was 2.19:1, error #D7443E was 4.01:1.
export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#183048",      // --o-primary
                // Three near-identical section/table bands — pale blue, pale
                // lilac and pale pink — that read as three different systems
                // next to the revamp's slate band. All now --o-surface-sunken.
                table_header: "#f1f5f9",
                table_header2: '#f1f5f9',
                table_header_3: '#f1f5f9',
                secondary: "#50AB26",
                background: "#f6f7fa",
                field_color: "#194E76",
                success: "#15803d",      // --o-success   2.80:1 -> 4.94:1
                error: "#b91c1c",        // --o-danger    4.01:1 -> 6.36:1
                warning: "#b45309",      // --o-warning   2.19:1 -> 4.91:1
                // `info` was never declared, so Vuetify used its own #2196F3 —
                // a Material blue on a navy product, and the fallback state for
                // every toast whose colour is not recognised.
                info: "#183048",         // --o-primary

                //login
                customTeal: "#00A991",
            }
        }
    }
});
